import Hls from 'hls.js';

export type LoadHlsParams = {
  src?: string;
  videoElement: HTMLMediaElement | HTMLVideoElement | null;
};

export const loadHls = ({ src, videoElement }: LoadHlsParams) =>
  new Promise<Hls>((resolve, reject) => {
    if (!src || !videoElement || !Hls.isSupported()) return;

    const hlsInstance = new Hls({
      // setting startLevel to -1 causes hls.js to automatically select quality level for the first part depending on the bandwidth
      // see https://github.com/video-dev/hls.js/blob/master/docs/API.md#hlsstartlevel
      startLevel: -1,
    });
    hlsInstance.attachMedia(videoElement);
    hlsInstance.loadSource(src);
    hlsInstance.on(Hls.Events.ERROR, (name, details) => {
      reject({ message: JSON.stringify(details), name });
    });
    hlsInstance.on(Hls.Events.MEDIA_ATTACHED, () => {
      hlsInstance.loadSource(src);
      hlsInstance.on(Hls.Events.MANIFEST_PARSED, () => {
        resolve(hlsInstance);
      });
    });
  });
